import { CommonOption } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const getBoxLabelRowId = (row: any) => 
  row.subjectboxid
 

export const getBoxLabelName = (row: any) =>
  row?.boxname ??
  "N/A";

export const getBoxLabelBarcode = (row: any) =>
  row?.boxbarcode ??
  "N/A";

export const getBoxLabelPeriod = (row: any) =>
  row?.period_number ??
  "N/A";

export const getBoxLabelSubjectNo = (row: any) =>
  row?.subjectno ??
  "N/A";

export const getBoxLabelAliquot = (row: any) =>
  row?.aliquot_number ??
  "N/A";

export const boxlabelFields = (
  studyOptions: CommonOption[],
  periodOptions: CommonOption[],
  aliquotOptions: CommonOption[],
  selectedStudyId: number | null | string,
  selectedPeriod: number | null | string
): FormFieldConfig[] => [
    {
      name: "studyid",
      label: "Study Code",
      type: "select",
      options: studyOptions,
      placeholder: "Select Study Code",
      required: true,
      disabled: true,
      rules: validations.cryovialLabel.studyid,
    },
    {
      name: "period",
      label: "Period",
      type: "select",
      options: periodOptions,
      placeholder: "Select Period",
      required: true,
      disabled: !selectedStudyId,
      rules: validations.cryovialLabel.period,
    },
    {
      name: "aliquot",
      label: "Aliquot Number",
      type: "select",
      options: aliquotOptions,
      placeholder: "Select Aliquot.No",
      required: true,
      disabled: !selectedPeriod,
      rules: validations.cryovialLabel.aliquot,
    },
  ];

  export const boxlabelColumns = (
    selectedBoxLabelIds: string[],
    toggleSelection: (data: any, checked: boolean) => void,
    isAllSelected?: boolean,
    handleSelectAll?: (isChecked: boolean) => void
  ) => [
    {
      key: "select",
      sticky: true,
      width: "50px",
      label: (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={isAllSelected || false}
            onChange={(e) => handleSelectAll?.(e.target.checked)}
          />
        </div>
      ),
      textCenter: true,
      render: (_: any, data: any) => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={selectedBoxLabelIds.includes(String(getBoxLabelRowId(data)))}
            onChange={(e) => toggleSelection(data, e.target.checked)}
          />
        </div>
      ),
    },
    {
      key: "boxname",
      label: "Box Name",
      sticky: true,
      width: "140px",
      render: (_: any, data: any) => getBoxLabelName(data),
    },
    {
      key: "period_number",
      label: "Period",
      render: (_: any, data: any) => getBoxLabelPeriod(data),
    },
    {
      key: "subjectno",
      label: "Sub No",
      render: (_: any, data: any) => {
        const val = getBoxLabelSubjectNo(data);
        return Number(val) >= 1 && Number(val) <= 9
          ? String(val).padStart(2, "0")
          : val;
      },
    },
    {
      key: "aliquot_number",
      label: "Aliquot",
      render: (_: any, data: any) => getBoxLabelAliquot(data),
    },
    {
      key: "boxbarcode",
      label: "Barcode",
      render: (_: any, data: any) => getBoxLabelBarcode(data),
    },
  ];
